import { fabric } from "fabric";

const SmallTree = fabric.util.createClass({
  type: "smallTree",
});

fabric.SmallTree = SmallTree;
